if (typeof window === 'undefined') {
    console.warn(
        `You are trying to use an @solublestudio/react-bootstrap-components component without adding it.`,
    );
}
